
import "./styles.scss"
import { observer } from 'mobx-react';

import { PPDModal } from 'pages/profile-dashboard/components/PPDModal';
import { PPDWidgetProductGroupsPricesList } from 'pages/profile-dashboard/components/PPDWidget/components/PPDWidgetProductGroupsPrices/components/PPDWidgetProductGroupsPricesList';
import { PPDWidgetProductGroupsPricesTable } from 'pages/profile-dashboard/components/PPDWidget/components/PPDWidgetProductGroupsPrices/components/PPDWidgetProductGroupsPricesTable';
import { useMedia } from 'shared/hooks';

type Props = {
    title?: string;
    isOpen: boolean;
    onClose: () => void;
    items: any[];
    labels: Record<string, string>
};

export const PPDWidgetProductGroupsPricesModal = observer(({
    title = '',
    onClose,
    isOpen,
    labels,
    items
}: Props) => {

    const { isMobileOrTablet } = useMedia();

    return (
        <PPDModal isOpened={isOpen} onClose={onClose} className="ppd-widget-product-groups-prices-modal">
            <div className="ppd-widget-product-groups-prices-modal__content">
                <div className="ppd-widget-product-groups-prices-modal__header">
                    <h3 className="ppd-widget-product-groups-prices-modal__title">{title}</h3>
                </div>
                { isMobileOrTablet
                    ?  <PPDWidgetProductGroupsPricesList labels={labels} items={items}/>
                    : <PPDWidgetProductGroupsPricesTable labels={labels} items={items} themeHead={"grey"}/>}
            </div>
        </PPDModal>
    );
});
